"use client";

import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthCover } from "@/components/auth";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-dvh w-full min-w-0 max-w-full flex-col bg-background md:flex-row">
      <AuthCover />

      <section className="flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col overflow-y-auto overscroll-y-contain bg-background px-6 py-5 lg:px-14 lg:py-6">
        <div className="flex w-full flex-1 flex-col items-center justify-center">
          <div className="w-full max-w-[440px] py-2">{children}</div>
        </div>
      </section>

      <Toaster position="bottom-right" />
    </div>
  );
}
